'use client';
// src/components/modal/constants.ts
var MODAL_NAME = "Modal";
var MODAL_CONTAINER_NAME = "ModalContainer";
var MODAL_CLOSE_NAME = "ModalClose";
var MODAL_NAVIGATION_NAME = "ModalNavigation";
var MODAL_NAVIGATION_ACTION_NAME = "ModalNavigationAction";
var MODAL_ACTION_AREA_NAME = "ModalActionArea";
var MODAL_ACTION_BUTTON_NAME = "ModalActionButton";

export { MODAL_ACTION_AREA_NAME, MODAL_ACTION_BUTTON_NAME, MODAL_CLOSE_NAME, MODAL_CONTAINER_NAME, MODAL_NAME, MODAL_NAVIGATION_ACTION_NAME, MODAL_NAVIGATION_NAME };
